module.exports = __webpack_public_path__ + "static/cf-bold-ext-a2cd36258b3dded68c38cdda9a57eb6f.ttf";